<template>
    <div class="section-segment" ref="section" :id="sectionReference">
        <component
            v-for="segment in segmentData.segments"
            :key="segment.id"
            :is="segment.type + '-segment'"
            :segment-data="segment.data"
            :id="segment.id"
        ></component>
    </div>
</template>

<script>
import TextSegment from "~/components/handbook/segments/Text";
import TitleSegment from "~/components/handbook/segments/Title";
import ImageSegment from "~/components/handbook/segments/Image";
import PoiSegment from "~/components/handbook/segments/Poi";
import VideoSegment from "~/components/handbook/segments/Video";
import EmbeddedMediaSegment from "~/components/handbook/segments/EmbeddedMedia";
import QuoteSegment from "~/components/handbook/segments/Quote";
import DividerSegment from "~/components/handbook/segments/Divider";
import ColumnsSegment from "~/components/handbook/segments/Columns";
import EmbedSegment from "~/components/handbook/segments/Embed";
import ProfileSegment from "~/components/handbook/segments/ProfileSegment";
import { slugify } from "@/utils";

export default {
    components: {
        TextSegment,
        TitleSegment,
        ImageSegment,
        DividerSegment,
        PoiSegment,
        VideoSegment,
        QuoteSegment,
        ColumnsSegment,
        EmbeddedMediaSegment,
        EmbedSegment,
        ProfileSegment,
    },

    props: {
        id: String,
        segmentData: Object,
    },

    computed: {
        sectionReference() {
            if (this.segmentData.title) {
                const slug = slugify(this.segmentData.title);
                const startsWithNumber = new RegExp("\^[0-9,-]"); // starts with a number or dash

                if (slug && !startsWithNumber.test(slug)) {
                    return `${slug}-${this.id}`;
                }
            }
            return `section-${this.id}`; //if no title, or title does not produce a suitable slug for a html ID.
        },
    },
};
</script>
